import { combineReducers } from '@reduxjs/toolkit';
import credentialDuck from '@/store/commonDuck/credentialDuck';
import NotificationDuck from '@/store/commonDuck/NotificationDuck';
import promoDuck from '@/store/commonDuck/promoDuck';
import orderDuck from '@/store/orderDuck';
import shippingInfoDuck from '@/store/shippingInfoDuck';
import consultationDuck from '@/store/consultationDuck';

const combinedReducers = combineReducers({
  credentials: credentialDuck,
  notification: NotificationDuck,
  promo: promoDuck,
  order: orderDuck,
  shippingInfo: shippingInfoDuck,
  consultation: consultationDuck,
});

export type RootState = ReturnType<typeof combinedReducers>;

export default combinedReducers;
